import { Guid, SerializableObject } from '../../common-react/core';

import { DocumentType } from '../other/document-type.enum';

export class ShipmentDocument extends SerializableObject {
  public id: Guid;
  public documentType: DocumentType;
  public name: string;
  public createdDateTime: Date;
}
